import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { User } from '../model/user.model';
import { LineProduction, ShiftProduction } from '../model/master.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';





const API_URL = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};


@Injectable()
export class MasterService {

  private Url = '';  // URL to web api
  currentUser: User;

  constructor(
    private http: HttpClient) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/master';
  }

  GetShiftProduction(): Observable<ShiftProduction[]> {
    return this.http.get<ShiftProduction[]>(this.Url + "/GetShiftProduction", httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetLineProduction(): Observable<LineProduction[]> {
    return this.http.get<LineProduction[]>(this.Url + "/GetLineProduction", httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/master.service.ts